<template>
  <div id="conteneur">
    <Toast />
    <HeaderHome :user="this.$store.state.user.prenom" />

    <div class="background">
      <div class="page-header">
        <div>
          <p class="breadcrumb"><span @click="goToHome" style="cursor:pointer">Accueil</span> > Fonctionnalité</p>
          <h1>Fonctionnalité</h1>
          <p class="subtitle">Gérez le tarif des prestations proposées aux élèves</p>
        </div>

        <div class="account-card">
          <p class="account-card-title">Mon compte</p>
          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Email</label>
              <input type="text" class="field-input" v-model="this.$store.state.user.email" />
            </div>
            <div class="field-group">
              <label class="field-label">Téléphone</label>
              <input type="text" class="field-input" v-model="this.$store.state.user.telephone" />
            </div>
          </div>
          <button class="btn btn-primary" @click="patchUtilisateur()">Modifier</button>
        </div>
      </div>

      <div class="panel">
        <div class="panel-header">
          <div>
            <p class="panel-label">Gestion</p>
            <h2 class="panel-title">Fonctionnalités</h2>
          </div>
          <button class="btn-add" v-if="!showForm" @click="openAddForm()">
            Nouvelle fonctionnalité
          </button>
        </div>

        <div class="add-edit-form" v-if="showForm">
          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Label</label>
              <input
                type="text"
                class="field-input"
                placeholder="Nom de la fonctionnalité"
                v-model="form.label"
                :disabled="form.id != null"
              />
            </div>
            <div class="field-group">
              <label class="field-label">Montant (€)</label>
              <input
                type="number"
                class="field-input"
                placeholder="Montant"
                v-model="form.montant"
              />
            </div>
          </div>
          <div class="form-actions">
            <button class="btn btn-primary" @click="CreateFonc">
              {{ form.id == null ? "Ajouter" : "Modifier" }}
            </button>
            <button class="btn btn-ghost" @click="cancelForm">Annuler</button>
          </div>
        </div>

        <DataTable :value="fonctionnalites" responsiveLayout="scroll" class="fonc-table">
          <Column field="label" header="Label"></Column>
          <Column field="montant" header="Montant">
            <template #body="slotProps">{{ slotProps.data.montant }} €</template>
          </Column>
          <Column header="" style="width: 110px">
            <template #body="slotProps">
              <div class="row-actions">
                <button class="icon-btn" @click="editFonc(slotProps.data)" title="Modifier">
                  <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M11 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
                <button class="icon-btn icon-btn--danger" @click="deleteFonc(slotProps.data)" title="Supprimer">
                  <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0l-1 14a2 2 0 01-2 2H7a2 2 0 01-2-2L4 6h16z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderHome from "../../../components/home/HeaderHome.vue";
import { useToast } from "primevue/usetoast";

export default {
  name: "Fonctionnalité",

  components: {
    HeaderHome,
  },

  data() {
    return {
      fonctionnalites: null,
      toast: useToast(),
      showForm: false,
      form: {
        id: null,
        label: "",
        montant: "",
      },
    };
  },
  mounted() {
    this.getFonctionnalites();
  },
  methods: {
    goToHome() {
      this.$router.push({ name: "Home" });
    },

    openAddForm() {
      this.form = { id: null, label: "", montant: "" };
      this.showForm = true;
    },

    cancelForm() {
      this.form = { id: null, label: "", montant: "" };
      this.showForm = false;
    },

    getFonctionnalites() {
      window.api
        .get("/fonctionnalites/", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.fonctionnalites = response.data["hydra:member"];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    CreateFonc() {
      if (this.form.label != "" && this.form.montant != "" && this.form.id == null) {
        window.api
          .post(
            "/fonctionnalites",
            {
              label: this.form.label,
              montant: parseInt(this.form.montant),
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then(() => {
            this.cancelForm();
            this.getFonctionnalites();
            this.toast.add({
              severity: "success",
              summary: "Fonctionnalité ajoutée",
              detail: "La fonctionnalité a été ajoutée avec succès",
              life: 3000,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.form.id == null) {
        alert("Veuillez saisir les champs");
      } else if (this.form.id != null) {
        window.api
          .patch(
            "/fonctionnalites/" + this.form.id,
            {
              montant: parseInt(this.form.montant),
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            }
          )
          .then(() => {
            this.cancelForm();
            this.getFonctionnalites();
            this.toast.add({
              severity: "success",
              summary: "Fonctionnalité modifiée",
              detail: "Le montant a été mis à jour avec succès",
              life: 3000,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    editFonc(info) {
      this.form.id = info.id;
      this.form.label = info.label;
      this.form.montant = info.montant;
      this.showForm = true;
    },
    deleteFonc(info) {
      let isExecuted = confirm(
        "Voulez vous vraiment supprimer la fonctionnalité : " + info.label
      );
      if (isExecuted) {
        window.api
          .delete("/fonctionnalites/" + info.id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then(() => {
            this.getFonctionnalites();
            this.toast.add({
              severity: "success",
              summary: "Fonctionnalité supprimée",
              detail: "La fonctionnalité a été supprimée avec succès",
              life: 3000,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    patchUtilisateur() {
      if (
        confirm(
          "Voulez vous vraiment modifier votre compte ? vous serez redirigé vers la page de connexion pour que la modification sois prise en compte"
        )
      ) {
        window.api
          .patch(
            `utilisateur/` + this.$store.state.user.id,
            {
              email: this.$store.state.user.email,
              telephone: this.$store.state.user.telephone,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.$emit("completed", response.data);
            this.toast.add({
              severity: "success",
              summary: "Compte modifié",
              detail: "Votre compte a été modifié avec succès",
              life: 3000,
            });
            this.$store.commit("setUser", null);
            this.$store.commit("setToken", null);
            localStorage.removeItem("user_info");
            localStorage.removeItem("user_access");
            this.$router.push({ name: "Connexion" });
          })
          .catch(function (error) {
            console.log(error.response);
          });
      }
    },
  },
  computed: {},
};
</script>

<style scoped>
#conteneur {
  background: #f4f6f9;
  min-height: 100vh;
}

.background {
  width: 70%;
  margin: auto;
  padding: 40px 0 60px;
  text-align: left;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 24px;
}

.breadcrumb {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

.page-header h1 {
  margin: 2px 0 4px;
  font-weight: bold;
}

.subtitle {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

.account-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px 22px;
  min-width: 340px;
}

.account-card-title {
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
}

.panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid #e2e8f0;
  gap: 12px;
}

.panel-label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
}

.panel-title {
  margin: 2px 0 0;
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
}

.btn-add {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  background: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s;
}

.btn-add:hover {
  background: #2563eb;
}

.add-edit-form {
  padding: 18px 22px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.field-row {
  display: flex;
  gap: 16px;
}

.field-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.field-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #1e293b;
  background: #fff;
  box-sizing: border-box;
}

.field-input:focus {
  outline: none;
  border-color: #3b82f6;
}

.field-input:disabled {
  background: #f1f5f9;
  color: #94a3b8;
}

.form-actions {
  display: flex;
  gap: 10px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, opacity 0.18s;
}

.btn-primary {
  background: #3b82f6;
  color: #ffffff;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-ghost {
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #64748b;
}

.btn-ghost:hover {
  background: #f1f5f9;
}

.row-actions {
  display: flex;
  gap: 8px;
}

.icon-btn {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  background: #fff;
  border-radius: 8px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s;
}

.icon-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.icon-btn--danger:hover {
  border-color: #f43f5e;
  color: #f43f5e;
}

/* DataTable */
:deep(.p-datatable) {
  font-size: 14px;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 22px;
  border-bottom: 1px solid #f3f4f6;
}

:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 14px 22px;
  border-bottom: 1px solid #f3f4f6;
  color: #111827;
}

@media (max-width: 900px) {
  .background {
    width: 92%;
  }

  .page-header {
    flex-direction: column;
  }

  .account-card {
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .field-row {
    flex-direction: column;
  }
}
</style>
